import React from 'react';
import useScrollTarget from '../../hooks/useScrollTarget';

import './sticky-bar.less';

export default function StickyBar({ id, children, height }) {
    const inRange = useScrollTarget(id, undefined, undefined, 0);
    return (
        <div id={id} className="stickyContainer" style={{ height }}>
            <div className={`stickyBar${inRange ? ' fixed' : ''}`}>{children}</div>
        </div>
    );
}
